import React from 'react';
import { styled } from 'styled-components';
import Close from '@/common/images/group.svg';

const Wrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	position: fixed;
	height: calc(var(--vh, 1vh) * 100);
	width: 100vw;
	top: 0;
	left: 0;
	background: rgba(175, 170, 179, 0.7);
	backdrop-filter: blur(8px);
	z-index: 90;
`;

const Box = styled.div`
	min-width: 320px;
	position: fixed;
`;

const Card = styled.div`
	border-radius: 10px;
	background: white;
	padding: 10px;
	max-height: calc(var(--vh, 1vh) * 90);
	overflow: hidden;
	overflow-y: auto;
`;

const PopUp = ({
	setClose = () => {},
	children,
	closeIcon = true,
	background = 'rgba(175, 170, 179, 0.7)',
	backdropFilter = 'blur(8px)',
}) => {
	return (
		<Wrapper
			style={{
				background,
				backdropFilter,
			}}
		>
			<div
				onClick={() => setClose((prev) => !prev)}
				style={{ width: '100%', height: '100%' }}
			></div>
			<Box>
				<Card>
					{closeIcon && (
						<div
							style={{
								position: 'absolute',
								right: '2px',
								top: '-3px',
							}}
						>
							<img
								src={Close}
								alt='close'
								style={{
									cursor: 'pointer',
									position: 'absolute',
									top: '14px',
									right: '8px',
									width: '14px',
									height: '14px',
								}}
								onClick={() => setClose((prev) => !prev)}
							/>
						</div>
					)}
					{children}
				</Card>
			</Box>
		</Wrapper>
	);
};

export default PopUp;
